import { useScrollRestore } from "@/hooks/useScrollRestore";
import OfflineBanner from "@/components/layout/OfflineBanner";

/**
 * Tiny wrapper that mounts inside BrowserRouter so it can use router hooks.
 * Adds: scroll-position restore on back-navigation + offline banner.
 */
export function GlobalUXEnhancers() {
  useScrollRestore();
  return <OfflineBanner />;
}

export default GlobalUXEnhancers;
